import { openContactPreview, openFundPreview, openInstitutionPreview } from '@capital-access/common/actions';
import { ProfileType } from '@capital-access/profiles/common';
import { ProfilePreviewType } from '../models/preview-type.model';

export function getProfileType(type: ProfilePreviewType): ProfileType {
  if (type === 'Institution') return ProfileType.Institution;
  if (type === 'Contact') return ProfileType.Contact;
  return ProfileType.Fund;
}

export function getProfilePreviewType(type: ProfileType): ProfilePreviewType {
  if (type === ProfileType.Institution) return 'Institution';
  if (type === ProfileType.Contact) return 'Contact';
  return 'Fund';
}

export function getProfilePreviewAction(type: ProfileType) {
  if (type === ProfileType.Institution) return openInstitutionPreview;
  if (type === ProfileType.Contact) return openContactPreview;
  return openFundPreview;
}
